import { BaseViewModel } from "@iot-platform/core";
import type { Station } from "@station/domain/models/station.model.ts";
import { injectable } from "inversify";
import { action, makeObservable, observable } from "mobx";

@injectable()
export class SensorComponentViewmodel extends BaseViewModel {
    @observable
    currentStation: Readonly<Station> | null = null;

    constructor() {
        super();
        makeObservable(this);
    }

    @action
    setStation(station: Readonly<Station>): void {
        this.currentStation = station;
    }
}
